import { useParams } from 'react-router-dom';

import ProductBook from 'components/Product/ProductBook/ProductBook';
import ProductCourse from 'components/Product/ProductCourse/ProductCourse';

const Product = () => {
  const { productType } = useParams();
  return (
    <>
      {productType === 'book' ? <ProductBook /> : <ProductCourse />}
    </>
  );
};

export default Product;
